import abstractModel from "../../core/MercatelyModel";
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}/retailer_users`;

const model = abstractModel(resource);

model.getAgentsByRole = async (filters = null) => {
  const newResource = `${resource}/by_role${filters ? `?${filters}` : ''}`;

  return model.get({}, { path: newResource });
};

model.getCurrentRetailerUser = async () => {
  const newResource = `${resource}/current_retailer_user`;

  return model.get({}, { path: newResource });
};

model.getCurrentRetailerUserInfo = async () => {
  const newResource = `/api/v1/current_retailer_user_info`;

  return model.get({}, { path: newResource });
};

model.updateNotifications = async (params) => {
  const newResource = `${resource}/update_notifications`;

  return model.save(params, { path: newResource });
};

export default model;
